import {ILayoutProperties} from "@/core/models/common/ILayoutProperties";

export class UserLayoutProperties implements ILayoutProperties {
}
